/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.ContentItemType_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.ContentItemType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum ContentItemType_ {
   /// <summary>
   ///   External Resource (ExtRes)
   /// </summary>
   ExternalResource = 1,
   /// <summary>
   ///   Article (Article)
   /// </summary>
   Article = 2,
   /// <summary>
   ///   Game (Game)
   /// </summary>
   Game = 3,
   /// <summary>
   ///   Quiz (Quiz)
   /// </summary>
   Quiz = 4,
   /// <summary>
   ///   Media (Media)
   /// </summary>
   Media = 5,
   /// <summary>
   ///   eBook (eBook)
   /// </summary>
   ebook = 6
}

export const ContentItemTypes: ContentItemType[] = [
   {
      code: ContentItemType_.ExternalResource,
      literal: 'ExternalResource',
      description: 'External Resource',
      shortDescription: 'ExtRes',
      listPriority: 0,

      isSearchable: true,

      typeName: "ContentItemType"
   },
   {
      code: ContentItemType_.Article,
      literal: 'Article',
      description: 'Article',
      shortDescription: 'Article',
      listPriority: 0,

      isSearchable: true,

      typeName: "ContentItemType"
   },
   {
      code: ContentItemType_.Game,
      literal: 'Game',
      description: 'Game',
      shortDescription: 'Game',
      listPriority: 0,

      isSearchable: true,

      typeName: "ContentItemType"
   },
   {
      code: ContentItemType_.Quiz,
      literal: 'Quiz',
      description: 'Quiz',
      shortDescription: 'Quiz',
      listPriority: 0,

      isSearchable: false,

      typeName: "ContentItemType"
   },
   {
      code: ContentItemType_.Media,
      literal: 'Media',
      description: 'Media',
      shortDescription: 'Media',
      listPriority: 0,

      isSearchable: true,

      typeName: "ContentItemType"
   },
   {
      code: ContentItemType_.ebook,
      literal: 'ebook',
      description: 'eBook',
      shortDescription: 'eBook',
      listPriority: 0,

      isSearchable: true,

      typeName: "ContentItemType"
   }
]

export class ContentItemType implements IDomainModel {
   code: ContentItemType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   isSearchable: boolean

   typeName: string

   static toDomainModel(code: ContentItemType_): ContentItemType {
      return ContentItemTypes.find(d => d.code === code)
   }
}
